import { h, Host } from "@stencil/core";
export class GxgFormRadio {
    constructor() {
        this.error = false;
        this.radioId = undefined;
        this.checked = false;
        this.disabled = false;
        this.label = undefined;
        this.name = undefined;
        this.value = undefined;
    }
    radioInput;
    /**
     * Emits the id and value of the radio when is checked.
     */
    radioChecked;
    /**
     * (This event is for internal use)
     */
    keyPressed;
    el;
    /*********************************
    METHODS
    *********************************/
    checkedHandler(newValue) {
        if (newValue) {
            this.radioChecked.emit({
                id: this.radioId,
                value: this.value
            });
        }
    }
    clickedHandler = () => {
        this.checked = true;
    };
    handlerOnKeyDown(e) {
        this.keyPressed.emit(e.key);
    }
    render() {
        return (h(Host, { class: { "gxg-form-radio--disabled": this.disabled } }, h("gxg-label", { noMargin: true, class: "label", disabled: this.disabled, onClick: this.clickedHandler }, h("input", { ref: el => (this.radioInput = el), type: "radio", name: this.name, value: this.value, disabled: this.disabled, onKeyDown: this.handlerOnKeyDown.bind(this), checked: this.checked, class: { checked: this.checked } }), h("span", { class: { radiobtn: true, "radiobtn--error": this.error } }), this.label)));
    }
    static get is() { return "gxg-form-radio"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["form-radio.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["form-radio.css"]
        };
    }
    static get properties() {
        return {
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Styles the radio-button with error attributes"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "radioId": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The radio id"
                },
                "attribute": "radio-id",
                "reflect": false
            },
            "checked": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute makes the radio selected by default"
                },
                "attribute": "checked",
                "reflect": true,
                "defaultValue": "false"
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The presence of this attribute disables the radio"
                },
                "attribute": "disabled",
                "reflect": true,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The radio label"
                },
                "attribute": "label",
                "reflect": false
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The radio name (should be the same for every radio of the same radio-group)"
                },
                "attribute": "name",
                "reflect": false
            },
            "value": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The radio value"
                },
                "attribute": "value",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "radioChecked",
                "name": "radioChecked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the id and value of the radio when is checked."
                },
                "complexType": {
                    "original": "RadioData",
                    "resolved": "{ value: string; id?: string; }",
                    "references": {
                        "RadioData": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/form-radio/form-radio.tsx",
                            "id": "src/components/form-radio/form-radio.tsx::RadioData"
                        }
                    }
                }
            }, {
                "method": "keyPressed",
                "name": "keyPressed",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "(This event is for internal use)"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
    static get watchers() {
        return [{
                "propName": "checked",
                "methodName": "checkedHandler"
            }];
    }
}
//# sourceMappingURL=form-radio.js.map
